import { useEffect } from 'react';
import { toast } from 'sonner';

type ErrorReportedEvent = CustomEvent<{
  area?: string;
  action?: string;
  severity?: string;
  reference?: string | null;
  suppressAck?: boolean;
}>;

export function ErrorReportAcknowledgement() {
  useEffect(() => {
    const handleErrorReported = (event: Event) => {
      const detail = (event as ErrorReportedEvent).detail;
      if (detail?.severity === 'info') return;
      // The caller already showed a specific toast (reportUserFacingError).
      if (detail?.suppressAck) return;

      toast.info('We have received this error report', {
        description: detail?.reference
          ? `Our tech team has been notified (ref ${detail.reference}) and will review it as soon as possible.`
          : 'Our team has been notified with the technical details and will review it as soon as possible.',
        duration: 7000,
      });
    };

    window.addEventListener('medd:error-reported', handleErrorReported);
    return () => window.removeEventListener('medd:error-reported', handleErrorReported);
  }, []);

  return null;
}
